<template>
  <v-card flat class="mt-5 main-theme">
    <v-form ref="changePasswordForm" v-model="isValid">
      <div class="px-3">
        <v-card-text class="pt-5">
          <v-row>
            <v-col cols="12" sm="8" md="6">
              <!-- current password -->
              <v-text-field
                v-model="formData.current_password"
                :type="isCurrentPasswordVisible ? 'text' : 'password'"
                :append-icon="
                  isCurrentPasswordVisible
                    ? icons.mdiEyeOffOutline
                    : icons.mdiEyeOutline
                "
                label="Current Password"
                outlined
                @copy.prevent
                @paste.prevent
                dense
                :rules="rules.currentPassword"
                @click:append="
                  isCurrentPasswordVisible = !isCurrentPasswordVisible
                "
              ></v-text-field>

              <!-- new password -->
              <v-text-field
                v-model="formData.new_password"
                :type="isNewPasswordVisible ? 'text' : 'password'"
                :append-icon="
                  isNewPasswordVisible
                    ? icons.mdiEyeOffOutline
                    : icons.mdiEyeOutline
                "
                label="New Password"
                outlined
                dense
                @copy.prevent
                @paste.prevent
                persistent-hint
                :rules="rules.password"
                @click:append="isNewPasswordVisible = !isNewPasswordVisible"
              ></v-text-field>

              <!-- confirm password -->
              <v-text-field
                v-model="formData.new_confirm_password"
                :type="isCPasswordVisible ? 'text' : 'password'"
                :append-icon="
                  isCPasswordVisible
                    ? icons.mdiEyeOffOutline
                    : icons.mdiEyeOutline
                "
                label="Confirm New Password"
                outlined
                dense
                @copy.prevent
                @paste.prevent
                :rules="rules.confirmPassword"
                class="mt-3"
                @click:append="isCPasswordVisible = !isCPasswordVisible"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="4"
              md="6"
              class="d-none d-sm-flex justify-center position-relative"
            >
              <v-img
                contain
                height="200"
                width="100%"
                src="../../../../assets/images/password-change.png"
                class="security-character"
              ></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </div>

      <!-- divider -->
      <v-divider></v-divider>

      <div class="pa-3">
        <v-card-title class="flex-nowrap">
          <v-icon class="text--primary me-3">
            {{ icons.mdiKeyOutline }}
          </v-icon>
          <span class="text-break">Two-factor authentication</span>
        </v-card-title>

        <v-card-text class="two-factor-auth text-center mx-auto">
          <v-avatar class="primary mb-4 profile-btn" rounded>
            <v-icon size="25" color="white">
              {{ icons.mdiLockOpenOutline }}
            </v-icon>
          </v-avatar>
          <p class="text-base text--primary font-weight-semibold">
            Two factor authentication is not enabled yet.
          </p>
          <p class="text-sm text--primary">
            Two-factor authentication adds an additional layer of security to
            your account by requiring more than just a password to log in. Learn
            more.
          </p>
        </v-card-text>
      </div>
    </v-form>
    <v-divider />
    <!-- action buttons -->
    <v-card-actions>
      <v-spacer />
      <v-btn class="me-3 my-3 profile-btn" @click="changePassword">
        Save changes
      </v-btn>
      <v-btn color="error" outlined class="my-3"> Cancel </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  mdiKeyOutline,
  mdiLockOpenOutline,
  mdiEyeOffOutline,
  mdiEyeOutline,
} from "@mdi/js";

export default {
  name: "AccountSettingsSecurity",
  data() {
    const isCurrentPasswordVisible = "";
    const isNewPasswordVisible = "";
    const isCPasswordVisible = "";
    const currentPassword = "";

    return {
      isCurrentPasswordVisible,
      isNewPasswordVisible,
      currentPassword,
      isCPasswordVisible,
      icons: {
        mdiKeyOutline,
        mdiLockOpenOutline,
        mdiEyeOffOutline,
        mdiEyeOutline,
      },
      isValid: false,
      submitting: false,
      formData: {
        new_password: "",
        current_password: "",
        new_confirm_password: "",
      },
    };
  },
  computed: {
    rules() {
      return {
        currentPassword: [(v) => !!v || "Current Password is required"],
        password: [
          (v) => !!v || "New password is required",
          (v) =>
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#~^()`.,;:{}_/%*?&])[A-Za-z\d@$!#~^()`.,;:{}_/%*?&]{8,16}$/.test(
              v,
            ) ||
            "Password should contain: Minimum 8 and maximum 16 characters, at least one uppercase letter, one lowercase letter, one number and one special character",
        ],
        confirmPassword: [
          (v) => !!v || "Password is required",
          (v) => v === this.formData.new_password || "Password does not match",
        ],
      };
    },
  },
  methods: {
    changePassword() {
      this.submitting = true;
      if (!this.isValid) {
        this.$refs.changePasswordForm.validate();
      } else {
        this.$store.dispatch("Auth/changePassword", { ...this.formData });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.two-factor-auth {
  max-width: 25rem;
}
.security-character {
  bottom: -0.5rem;
}
</style>
